import { useQuery } from '@tanstack/react-query';
import api from '../../../lib/api';
import { Skill } from './skill-registry';

interface Workspace {
  id: string;
  configured: boolean;
  name?: string;
}

interface PleriStatus {
  isOnboarded: boolean;
  isEnabled: boolean;
  isLimitedFunctionality: boolean;
  showPleriInDashboard: boolean;
  isChatEnabled: boolean;
  skills: {
    count: number;
    items: Skill[];
  };
  workspaces: {
    count: number;
    items: Workspace[];
  };
  // Usage control flags
  stopPremiumRequests?: boolean; // When premium request limit is reached
  stopUsage?: boolean; // When cost limit is reached
  // Super simple usage summary
  usage?: {
    // Premium requests
    premiumRequests: {
      used: number;
      limit: number;
      remaining: number;
    };
    // Total monthly requests
    monthlyRequests: {
      used: number;
    };
    // Monthly cost
    monthlyCost: {
      used: number;
      limit: number;
      remaining: number;
    };
  };
  defaultModelId: string;
  defaultNonPremiumModelId: string;
}

export const usePleriStatus = (enabled = true) => {
  return useQuery({
    queryKey: ['pleriStatus'],
    queryFn: async () => {
      const { data } = await api.get<{ data: PleriStatus }>(
        '/api/core/pleri/status',
      );
      return {
        ...data?.data,
      };
    },
    enabled,
    // Cache for 5 minutes since this affects UI visibility
    staleTime: 5 * 60 * 1000,
  });
};
